<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     新建收费方案须知
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog class="el-clause" width="900px" :visible.sync="clauseShow" :modal-append-to-body="false" :close-on-click-modal="false" @close="onDialogClose">
    <span slot="title">
      <span class="dia-title">收费方案相关须知</span>
    </span>
    <el-scrollbar :native="false">
      <div v-loading="loading">
        <el-form ref="notice" :model="notice" :rules="noticeRules" label-position="left" label-width="120px">
          <div class="notice">
            <span class="iconfont text-blue icon-basic-information" style="font-size:65px"></span>
          </div>
          <div class="notice-title">
            确认新建收费方案？
          </div>
          <div style="margin: 20px 40px 10px;">
            <div class="rule-title">
              新建方案前，请确保：
            </div>
            <ul v-for="(item, index) in rules" :key="index" class="rule-content">
              <li class="li-content" style="margin: 12px 0;">
                {{ item }}
              </li>
            </ul>
          </div>
          <el-checkbox v-model="checked" style="margin: 0 50px;color: #333;">已阅读并了解收费方案相关须知</el-checkbox>
        </el-form>
      </div>
    </el-scrollbar>
    <div slot="footer" class="text-center mb">
      <el-button class="extend" @click="cancel">取消</el-button>
      <el-button class="extend" type="primary" :disabled="!checked" @click="submit">下一步</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { agreementApi } from '@/api/ei/eiApi'

export default {
  name: 'EiClause',

  components: {
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      rules: [],
      checked: false,
      loading: false,
      notice: {
      },
      noticeRules: {
      }
    }
  },

  computed: {
    clauseShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  watch: {
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      agreementApi().then(res => {
        this.loading = false
        if (!res.errno) {
          this.rules = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },

    onDialogClose() {
      this.checked = false
    },

    submit() {
      this.$router.push('/ei/scheme/detail?schemeid=0')
      this.clauseShow = false
    },

    cancel() {
      this.clauseShow = false
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.el-clause{
  .el-scrollbar {
    height: 100%;
    >.el-scrollbar__wrap {
      overflow-x: hidden;
      >.el-scrollbar__view {
        padding: 0 0 25px 0;
      }
    }
  }
}
.dia-title {
  font-size: 18px;
}
.notice {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  .notice-icon {
    width: 6em;
    height: 6em;
  }
}
.notice-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #333;
}
.rule-title {
  color: #888;
}
.rule-content {
  color: #888;
  padding: 0 0 0 20px;
}
</style>
